'use client';
import React, { FC, useEffect, useState } from 'react';

import Image from '@/components/core/Image';
import popok0 from '@/public/assets/Images/loading/popok0.png';
import popok1 from '@/public/assets/Images/loading/popok1.png';
import popok10 from '@/public/assets/Images/loading/popok10.png';
import popok11 from '@/public/assets/Images/loading/popok11.png';
import popok12 from '@/public/assets/Images/loading/popok12.png';
import popok13 from '@/public/assets/Images/loading/popok13.png';
import popok14 from '@/public/assets/Images/loading/popok14.png';
import popok15 from '@/public/assets/Images/loading/popok15.png';
import popok16 from '@/public/assets/Images/loading/popok16.png';
import popok17 from '@/public/assets/Images/loading/popok17.png';
import popok18 from '@/public/assets/Images/loading/popok18.png';
import popok19 from '@/public/assets/Images/loading/popok19.png';
import popok2 from '@/public/assets/Images/loading/popok2.png';
import popok20 from '@/public/assets/Images/loading/popok20.png';
import popok21 from '@/public/assets/Images/loading/popok21.png';
import popok22 from '@/public/assets/Images/loading/popok22.png';
import popok23 from '@/public/assets/Images/loading/popok23.png';
import popok24 from '@/public/assets/Images/loading/popok24.png';
import popok25 from '@/public/assets/Images/loading/popok25.png';
import popok26 from '@/public/assets/Images/loading/popok26.png';
import popok27 from '@/public/assets/Images/loading/popok27.png';
import popok28 from '@/public/assets/Images/loading/popok28.png';
import popok29 from '@/public/assets/Images/loading/popok29.png';
import popok3 from '@/public/assets/Images/loading/popok3.png';
import popok30 from '@/public/assets/Images/loading/popok30.png';
import popok31 from '@/public/assets/Images/loading/popok31.png';
import popok32 from '@/public/assets/Images/loading/popok32.png';
import popok33 from '@/public/assets/Images/loading/popok33.png';
import popok34 from '@/public/assets/Images/loading/popok34.png';
import popok35 from '@/public/assets/Images/loading/popok35.png';
import popok36 from '@/public/assets/Images/loading/popok36.png';
import popok37 from '@/public/assets/Images/loading/popok37.png';
import popok38 from '@/public/assets/Images/loading/popok38.png';
import popok39 from '@/public/assets/Images/loading/popok39.png';
import popok4 from '@/public/assets/Images/loading/popok4.png';
import popok40 from '@/public/assets/Images/loading/popok40.png';
import popok41 from '@/public/assets/Images/loading/popok41.png';
import popok42 from '@/public/assets/Images/loading/popok42.png';
import popok43 from '@/public/assets/Images/loading/popok43.png';
import popok44 from '@/public/assets/Images/loading/popok44.png';
import popok45 from '@/public/assets/Images/loading/popok45.png';
import popok46 from '@/public/assets/Images/loading/popok46.png';
import popok47 from '@/public/assets/Images/loading/popok47.png';
import popok48 from '@/public/assets/Images/loading/popok48.png';
import popok49 from '@/public/assets/Images/loading/popok49.png';
import popok5 from '@/public/assets/Images/loading/popok5.png';
import popok50 from '@/public/assets/Images/loading/popok50.png';
import popok51 from '@/public/assets/Images/loading/popok51.png';
import popok52 from '@/public/assets/Images/loading/popok52.png';
import popok53 from '@/public/assets/Images/loading/popok53.png';
import popok54 from '@/public/assets/Images/loading/popok54.png';
import popok55 from '@/public/assets/Images/loading/popok55.png';
import popok56 from '@/public/assets/Images/loading/popok56.png';
import popok57 from '@/public/assets/Images/loading/popok57.png';
import popok58 from '@/public/assets/Images/loading/popok58.png';
import popok59 from '@/public/assets/Images/loading/popok59.png';
import popok6 from '@/public/assets/Images/loading/popok6.png';
import popok60 from '@/public/assets/Images/loading/popok60.png';
import popok61 from '@/public/assets/Images/loading/popok61.png';
import popok62 from '@/public/assets/Images/loading/popok62.png';
import popok63 from '@/public/assets/Images/loading/popok63.png';
import popok64 from '@/public/assets/Images/loading/popok64.png';
import popok65 from '@/public/assets/Images/loading/popok65.png';
import popok66 from '@/public/assets/Images/loading/popok66.png';
import popok67 from '@/public/assets/Images/loading/popok67.png';
import popok68 from '@/public/assets/Images/loading/popok68.png';
import popok69 from '@/public/assets/Images/loading/popok69.png';
import popok7 from '@/public/assets/Images/loading/popok7.png';
import popok70 from '@/public/assets/Images/loading/popok70.png';
import popok71 from '@/public/assets/Images/loading/popok71.png';
import popok8 from '@/public/assets/Images/loading/popok8.png';
import popok9 from '@/public/assets/Images/loading/popok9.png';
import './styles.scss';

const Loading: FC = () => {
  const [activeFrame, setActiveFrame] = useState(0);
  const frames = [
    popok0,
    popok1,
    popok2,
    popok3,
    popok4,
    popok5,
    popok6,
    popok7,
    popok8,
    popok9,
    popok10,
    popok11,
    popok12,
    popok13,
    popok14,
    popok15,
    popok16,
    popok17,
    popok18,
    popok19,
    popok20,
    popok21,
    popok22,
    popok23,
    popok24,
    popok25,
    popok26,
    popok27,
    popok28,
    popok29,
    popok30,
    popok31,
    popok32,
    popok33,
    popok34,
    popok35,
    popok36,
    popok37,
    popok38,
    popok39,
    popok40,
    popok41,
    popok42,
    popok43,
    popok44,
    popok45,
    popok46,
    popok47,
    popok48,
    popok49,
    popok50,
    popok51,
    popok52,
    popok53,
    popok54,
    popok55,
    popok56,
    popok57,
    popok58,
    popok59,
    popok60,
    popok61,
    popok62,
    popok63,
    popok64,
    popok65,
    popok66,
    popok67,
    popok68,
    popok69,
    popok70,
    popok71,
  ];

  const totalFrames = frames.length;
  const animationSpeed = 1000 / 30; // 30 frames per second

  useEffect(() => {
    let animationFrameId: any;
    let lastFrameTime = 0;

    const animate = (currentTime: number) => {
      if (currentTime - lastFrameTime >= animationSpeed) {
        setActiveFrame((prevFrame) => (prevFrame + 1) % totalFrames);
        lastFrameTime = currentTime;
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameId);
  }, [totalFrames, animationSpeed]);

  return (
    <div className="loading-container">
      <div className="loading-inner">
        <Image src={frames[activeFrame]} alt="Loading animation" loading="eager" />
      </div>
    </div>
  );
};

export default Loading;
